export default {
  brand: "quickwill",
  name: "QuickWill",
  homeUrl: "www.quickwill.co.za",
  pageTitle: "Create Your Will Online | Quick And Easy",
  estateAssistEnabled: false,
  overviewPageTitle: "Quickwill!",
  overviewPartnershipTitle: "",
  showTrustpilot: false,
  facebookPageUrl: "https://www.facebook.com/quickwill.za",
  linkedInPageUrl: "https://www.linkedin.com/company/quickwill-za",
  contactAddress: "Mutualpark, Jan Smuts Drive",
  contactAddressRedesign: "",
  contactTelNumber: "021 753 8236",
  contactEmail: "hello@quickwill.co.za",
  showHomePageTestimonials: true,
  showHomePageAbout: false,
  FAQUrl: "http://support.quickwill.co.za",
  blogUrl: null,
  showFinancialAdvisorExplainerPage: true,
  showExecutorExplainerPage: true,
  advisorPageShowPartnerLogos: true,
  showQWExecutorLinks: true,
  showTrustLearnMoreLink: true,
  termsAndConditionsLocation: "pdfs/quickwill/terms-and-conditions.pdf",
  privacyNoticeLocation: "pdfs/quickwill/privacy-policy.pdf",
  cookiePolicyLocation: "pdfs/quickwill/cookie-policy.pdf",
  canonicalUrls: {
    homepage: "https://quickwill.co.za",
    signup: "https://quickwill.co.za/signup",
    login: "https://quickwill.co.za/login",
    termsAndConditions: null,
    competitionTermsAndConditions: null,
    forgotPassword: "https://quickwill.co.za/forgot-password",
  },
  meta: {
    data: [
      {
        property: "description",
        content:
          "Create your will online with QuickWill's easy, secure, and free platform. Draft and download your will in four simple steps without needing a lawyer.",
      },
      { property: "og:title", content: "Quickwill: Your will done your way" },
      {
        property: "og:image",
        content: "https://quickwill.co.za/meta/quickwill.png",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "/" },
      {
        property: "og:description",
        content:
          "Protect your family by creating your legally binding will, online, in just minutes.",
      },
      { property: "og:site_name", content: "Quickwill" },
    ],
    links: {
      favicon: "/favicon.ico",
      font: "https://fonts.googleapis.com/css?family=Nunito:100,300,400,500,700,900",
    },
    scripts: [
      {
        type: "application/ld+json",
        json: {
          "@context": "http://schema.org",
          "@type": "Organization",
          name: "Quickwill",
          url: "https://quickwill.co.za",
          address: "Mutualpark, Jan Smuts Drive, Cape Town",
          sameAs: [
            "https://www.facebook.com/quickwill.za",
            "https://twitter.com/Quickwill2",
            "https://www.linkedin.com/company/quickwill-za/",
          ],
        },
      },
    ],
  },
  sso: {
    googleSsoEnabled: false,
    googleClientId:
      "311768930697-alolgso3c0ip6n8npne6s30cf7vsknqg.apps.googleusercontent.com",
    facebookSsoEnabled: false,
    facebookAppId: "",
  },
  colors: {
    buttonPrimary: "#3ADEB4",
    buttonPrimaryHover: "#32CAA3",
  },
  testamentaryTrustData: [
    {
      title: "<h2>Why Testamentary Trusts Are Important</h2>",
      content: `<p>A testamentary trust is created in your will and activates upon your death. It ensures that your assets 
      are managed according to your wishes, providing financial security for vulnerable beneficiaries like minor children or dependent family members.</p>`,
    },
    {
      title: "<h2>Who Should Consider Setting Up a Testamentary Trust?</h2>",
      content: `<p>If you have minor children, vulnerable family members, or want to ensure your loved ones' inheritance 
      is wisely managed, a testamentary trust is an essential tool in safeguarding their financial future.  
      Setting up a testamentary trust is particularly relevant if you are leaving more than R500 000 to your beneficiaries. </p>`,
    },
    {
      title: "<h2>Purpose and Benefits of a Testamentary Trust</h2>",
      content: `<p>In South Africa, minor children cannot receive inheritance directly. A testamentary trust ensures that their 
      inheritance is managed in their best interests, allowing you to control how and when funds are distributed to your loved ones.</p>`,
    },
    {
      title: "<h2>How Testamentary Trusts Are Established and Managed</h2>",
      content: `<p>A testamentary trust is created through instructions in your will. It only comes into effect after your death, 
      and it’s essential to ensure your will is legally valid to avoid nullifying the trust.</p>`,
    },
    {
      title: "<h2>Appointing a Trustee: What to Consider</h2>",
      content: `<p>The trustee manages the trust’s assets and must act in the best interest of the beneficiaries. 
      Consider appointing an independent trustee to avoid conflicts of interest, especially if the trustee is also the guardian of your children.</p>`,
    },
    {
      title:
        "<h2>Testamentary Trusts When Creating Your Will With QuickWill</h2>",
      content: `<p>QuickWill offers the option to set up a testamentary trust as part of the online will creation process. 
      This ensures your loved ones are protected in alignment with your wishes.</p>`,
    },
  ],
  executorData: [
    {
      title: "<h2>Understanding the Role of an Executor</h2>",
      content: `<p>An executor is responsible for managing your estate after your passing. Their duties include gathering information about 
      assets and liabilities, paying debts, managing assets, distributing inheritances, and resolving disputes. This role requires a deep understanding of legal and financial matters.</p>`,
    },
    {
      title: "<h2>Why Choosing the Right Executor is Crucial</h2>",
      content: `<p>Selecting the right executor for your estate is vital to ensure that your final wishes are carried out and your loved ones are cared for. 
      An executor needs to be trustworthy, competent, and experienced in estate administration to manage your estate effectively.</p>`,
    },
    {
      title: "<h2>Should You Appoint a Family Member or a Professional?</h2>",
      content: `<p>While appointing a family member may seem logical, estate administration requires expertise that most people lack. 
      The Master of the High Court may require a layperson to hire a professional representative. A professional executor, like Old Mutual, ensures that your estate is managed efficiently and in accordance with legal requirements.</p>`,
    },
    {
      title: "<h2>Executor Fees: What You Need to Know</h2>",
      content: `<p>Executor fees in South Africa are set at 3.5% of the gross value of the estate plus VAT. 
      Executors also charge 6% (plus VAT) of income generated during the administration period. It’s important to ensure that your estate has enough cash flow to cover these costs to avoid selling assets intended for beneficiaries.</p>`,
    },
    {
      title: "<h2>How QuickWill Can Assist With Executor Services</h2>",
      content: `<p>QuickWill offers professional executor services, bringing extensive experience in estate administration. They can efficiently handle legal, financial, and administrative tasks, 
      ensuring your estate is managed with care, allowing your family to focus on what matters most during a difficult time.</p>`,
    },
    {
      title:
        "<h2>Planning Ahead With QuickWill’s Estate Administration Calculator</h2>",
      content: `<p>QuickWill provides an estate administration costs calculator to help you estimate the costs involved in administering your estate. 
      This tool aids in planning to avoid unnecessary liquidation of assets, ensuring your beneficiaries receive what you intended. 
      Through the steps in this process we will provide you the opportunity to do a detailed cost calculation.</p>`,
    },
    {
      title: "<h2>The Importance of Professional Executor Services</h2>",
      content: `<p>Choosing a professional executor like QuickWill ensures your estate is managed expertly, 
      safeguarding your legacy and providing peace of mind. Their expertise helps navigate the complexities of estate administration, 
      ensuring your final wishes are honoured. QuickWill administers estates through Online Wills Estate Administrators.</p>`,
    },
  ],
  livingWillData: [
    {
      title: "<h2>What Is a Living Will?</h2>",
      content: `<p>A Living Will is a legal document that specifies your medical treatment preferences if you become unable to make decisions 
      due to illness or incapacity. It ensures your healthcare choices are respected, even when you can’t communicate them.</p>`,
    },
    {
      title: "<h2>Importance of Creating a Living Will</h2>",
      content: `<p>Creating a Living Will is crucial for ensuring your end-of-life care aligns with your values and preferences. 
      QuickWill offers a straightforward process for creating a Living Will, ensuring your wishes are legally documented and respected.</p>`,
    },
    {
      title: "<h2>Purpose of a Living Will in End-of-Life Planning</h2>",
      content: `<p>The main purpose of a Living Will is to outline your wishes regarding life-sustaining treatments, such as resuscitation or 
      artificial nutrition, in cases of terminal illness or permanent unconsciousness. It provides clear guidance on the medical interventions you do or do not want.</p>`,
    },
    {
      title: "<h2>Legal Standing of Living Wills in South Africa</h2>",
      content: `<p>In South Africa, Living Wills are recognised under common law, meaning they are generally respected by healthcare providers 
      despite not being governed by specific legislation. Clear and specific instructions in your Living Will help avoid ambiguity.</p>`,
    },
    {
      title:
        "<h2>Differences Between a Living Will and a Last Will and Testament</h2>",
      content: `<p>A Living Will specifies your medical treatment preferences if you become incapacitated, focusing on healthcare decisions. 
      A Last Will and Testament, on the other hand, deals with the distribution of your assets and guardianship of minors after your death.</p>`,
    },
    {
      title: "<h2>Why a Living Will Is Important in South Africa</h2>",
      content: `<p>Creating a Living Will is important for ensuring your medical treatment preferences are known, guiding healthcare providers, reducing family conflicts, 
      and bringing peace of mind. It also encourages open discussions about end-of-life care with loved ones.</p>`,
    },
    {
      title: "<h2>How to Create a Living Will in South Africa</h2>",
      content: `<p>To create a Living Will, reflect on your medical preferences, consult healthcare providers if needed. 
      You can then create your Living Will as part of the online process with QuickWill’s online will creation service.</p>`,
    },
    {
      title: "<h2>Appointing a Healthcare Proxy in South Africa</h2>",
      content: `<p>A healthcare proxy is someone you designate to make medical decisions on your behalf if you’re incapacitated. Choose a responsible 
      person, document the appointment, and ensure they understand your preferences. Formalize this with a power of attorney for healthcare.</p>`,
    },
    {
      title:
        "<h2>Living Will vs. Living Trust: Understanding the Difference</h2>",
      content: `<p>A Living Will outlines your medical preferences if you’re incapacitated, while a Living Trust manages your assets during 
      your lifetime and after death. The Living Will focuses on healthcare, while the Living Trust handles financial matters.</p>`,
    },
    {
      title: "<h2>Living Will vs. Do Not Resuscitate (DNR) Orders</h2>",
      content: `<p>A Living Will covers various medical treatment preferences, including end-of-life care. A DNR order specifically 
      instructs healthcare providers not to perform CPR if your heart stops, focusing on one aspect of your overall medical care plan.</p>`,
    },
  ],
  videos: {
    childrensGuardianVideo: "https://youtube.com/embed/g5ck29UYUbY?rel=0",
    testamentaryTrustVideo: "https://youtube.com/embed/YAWjvCB5jw8?rel=0",
    executorVideo: "https://youtube.com/embed/OyyvbVFKbD4?rel=0",
    livingWillVideo: "https://youtube.com/embed/JHyYA_y3pic?rel=0",
    maritalRegimeVideo: "https://youtube.com/embed/gzchzrHU_bc?rel=0",
    inheritanceChoicesVideo: "https://youtube.com/embed/v-3-I2NYPpg?rel=0",
  },
  omDesign: false,
};
